import { socketMonitor } from './socket-monitor';
import { httpMonitor } from './http-monitor';
import { appMonitor } from './app-monitor';
import { screenMonitor } from './screen-monitor';
import { environment } from '@env';

export const monitorLogger = (() => {
  // const AmplitudelogEvent = (eventName: string, props?: any) => {
  //   if (props && typeof props === 'object') {
  //     amplitude.logEvent(eventName, props);
  //     showLog(eventName, props);
  //   } else {
  //     amplitude.logEvent(eventName);
  //     showLog(eventName);
  //   }
  // };

  const gaLogEvent = (eventName: string, props?: any) => {
    if (props && typeof props === 'object') {
      window.gtag?.('event', eventName, props);
      showLog(eventName, props);
    } else {
      window.gtag?.('event', eventName);
      showLog(eventName);
    }
  };

  const showLog = (eventName: string, eventProps?: any) => {
    if (!environment.production) {
      if (eventProps) {
        console.log(eventName, eventProps);
      } else {
        console.log(eventName);
      }
    }
  };

  const trackEventHttp = (method: string, status: number, url: string, props?: any) => {
    // AmplitudelogEvent(`[HTTP]${status ? `[${status}]` : `[${method?.toUpperCase()}]`} ${url}`, props);
  };

  const trackEventApp = (eventName: string, props?: any) => {
    // AmplitudelogEvent(`[APP]${eventName}`, props);
  };

  const trackEventSocket = (eventName: string, props?: any) => {
    //AmplitudelogEvent(`[SOCKET][${eventName}]`, props);
  };

  const trackEventScreen = (screenName: string, eventName: string, props?: any) => {
    gaLogEvent(`${eventName.toLowerCase()}`, {
      screen: screenName,
      ...props,
    });
  };

  const identifyProfile = (
    profileId: string,
    email: string,
    cpf: string,
    gender: string,
    profileType: string,
    group: string,
  ) => {};

  const clearProfile = () => {};

  const initializeAnalytics = (env: string) => {};

  return {
    initializeAnalytics,
    identifyProfile,
    clearProfile,
    socket: socketMonitor(trackEventSocket),
    http: httpMonitor(trackEventHttp),
    app: appMonitor(trackEventApp),
    screen: screenMonitor(trackEventScreen),
  };
})();
